import React from 'react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-brand-red text-white py-2.5 px-4 shadow-md" data-id="element-374">
      <p className="max-w-4xl mx-auto text-sm sm:text-base font-semibold text-center" data-id="element-375">
        🔥 EDICIÓN 2026 — Solo para las próximas 20 mujeres. Accede por $27
        antes de que suba a $67.
      </p>
    </div>;
}